import React from 'react'

const Imaging = () => {
  return (
    <div>Imaging</div>
  )
}

export default Imaging